import { useSelector } from 'react-redux';
import { RootState } from 'Store/index';
import { Feature, isAvailable } from 'App/services/FeatureHelperStandalone';

const useMailTemplatesAllowed = () => {
	const { metadata, mailIntegration } = useSelector(({ App }: RootState) => App);
	const hasEmail = isAvailable(Feature.EMAIL);
	if ((metadata?.map.mailActivated || mailIntegration) && hasEmail) {
		return true;
	}
	return false;
};

export default useMailTemplatesAllowed;
